// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import '../../styles/containers/Party.css';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { FormGroup, Form } from 'react-bootstrap';
import SimpleSelect from '../utils/FormWidgets/SimpleSelect';

class State {
  memberForAssign = '';
  firstPlanner = '';
}

export default class MemberKickForm extends React.Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { members } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    const firstPlanner = members.find(
      member => member.memberRole === 'planner' || member.memberRole === 'bach'
    );
    if (firstPlanner) {
      this.setState({
        firstPlanner: firstPlanner.memberId,
        memberForAssign: firstPlanner.memberId,
      });
    } else {
      this.setState({
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        firstPlanner: members[0].memberId,
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        memberForAssign: members[0].memberId,
      });
    }
  }

  handleFormChange = value => {
    this.setState({
      memberForAssign: value,
    });
  };

  deleteMember = async e => {
    e.preventDefault();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleOnDelete } = this.props;
    const { memberForAssign } = this.state;
    await handleOnDelete(memberForAssign);
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { name, members } = this.props;
    const { memberForAssign, firstPlanner } = this.state;
    return (
      <div className='kick-form'>
        <div
          style={{
            marginBottom: '20px',
            marginRight: '40px',
            fontSize: '18px',
          }}
        >
          Are you really want to remove <b>{name}</b> from this party?
        </div>
        <Form>
          {true && (
            <FormGroup>
              <p>
                Please, select another member to reassign related
                expenses/payment:
              </p>
              <div style={{ fontSize: '16px', fontWeight: 'normal' }}>
                <SimpleSelect
                  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                  // @ts-ignore
                  onChange={this.handleFormChange}
                  style={{ width: '200px' }}
                  value={memberForAssign}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  data={members.map(member => ({
                    value: member.memberId,
                    label: member.memberName,
                    selected: member.memberId === firstPlanner,
                  }))}
                />
              </div>
            </FormGroup>
          )}
          <button
            type='submit'
            onClick={this.deleteMember}
            className='btn btn-primary pull-right'
            style={{ marginRight: '0px' }}
          >
            Delete Member
          </button>
        </Form>
      </div>
    );
  }
}
